
import { Component, Vue, Prop } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnMap } from "@/models/api/asn/map";

const asnModule = getModule(AsnModule);

@Component
export default class CreateMapModal extends Vue {
    MapName: string = '';

    @Prop({ default: 0 })
    Level: AsnLevel;

    created(){
        console.log('created map modal');
    }

    async onSubmit() {
        let result = await asnModule.createMap({
            displayName: this.MapName,
            asnLevel: this.Level
        });

        if (result !== null && result !== undefined){
            this.$emit('map-created', result);
        }
    }
}

